import Papa from 'papaparse';

/**
 * @param {Record<string, unknown>} pt
 * @param {'gross' | 'net'} roasView
 * @returns {string}
 */
function formatRoasVectorCellForCsv(pt, roasView) {
  const display =
    pt.roasDisplay != null && String(pt.roasDisplay).trim() !== ''
      ? String(pt.roasDisplay).trim()
      : '';
  if (display) {
    return display;
  }
  const raw =
    roasView === 'net'
      ? pt.netRoasPct ?? pt.net_roas_pct
      : pt.grossRoasPct ?? pt.gross_roas_pct;
  if (raw === undefined || raw === null || Number.isNaN(Number(raw))) {
    return '';
  }
  return `${(Number(raw) * 100).toFixed(2)}%`;
}

/**
 * @param {Record<string, unknown>} payload - saved tearsheet payload (`payloadJson`)
 * @returns {string} CSV text or empty string if no cohort or vector data
 */
export function buildRoasCohortCsvString(payload) {
  const roasView = payload.roasGrossNetView === 'net' ? 'net' : 'gross';
  const chunks = [];

  const cohort = payload?.roasCohort;
  const rows = cohort?.rows;
  const periodLabels = Array.isArray(cohort?.periodLabels) ? cohort.periodLabels : [];

  if (Array.isArray(rows) && rows.length > 0) {
    const header = ['Cohort', ...periodLabels.map((p) => `P${p}`)];

    const dataRows = rows.map((row) => {
      const label = row?.cohortLabel != null ? String(row.cohortLabel) : '';
      const cells = Array.isArray(row.cells) ? row.cells : [];
      const byPeriod = new Map(
        cells.map((c) => [String(c.period), c])
      );
      const values = periodLabels.map((period) => {
        const cell = byPeriod.get(String(period));
        if (!cell) {
          return '';
        }
        const raw =
          roasView === 'net' ? cell.netRoasPct : cell.grossRoasPct;
        if (raw === undefined || raw === null || Number.isNaN(Number(raw))) {
          return '';
        }
        return `${(Number(raw) * 100).toFixed(2)}%`;
      });
      return [label, ...values];
    });

    chunks.push(Papa.unparse([header, ...dataRows]));
  }

  const vector = Array.isArray(payload?.cashflowRoasVector)
    ? payload.cashflowRoasVector
    : [];
  if (vector.length > 0) {
    const sectionTitle = `ROAS vector (${roasView})`;
    const mobHeader = [
      'MOB',
      ...vector.map((pt) =>
        pt.mobIndex != null && String(pt.mobIndex) !== ''
          ? `M${pt.mobIndex}`
          : 'M—'
      ),
    ];
    const roasRow = [
      'ROAS',
      ...vector.map((pt) => formatRoasVectorCellForCsv(pt, roasView)),
    ];
    chunks.push(`${sectionTitle}\n${Papa.unparse([mobHeader, roasRow])}`);
  }

  return chunks.join('\n\n');
}
